import { Component, OnInit, HostBinding } from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {AnimationsMetaData} from '../../_animations/animations.metadata';
import {Subscription} from 'rxjs/Subscription';
import {AnimationService} from '../../_animations/animations.service';
import {RouteDirections, IRouteDirection} from '../../_animations/route-directions.constant';

@Component({
  selector: 'app-vinna',
  providers: [AnimationService, RouteDirections],
  templateUrl: './vinna.component.html',
  styleUrls: ['./vinna.component.css'],
  animations: [AnimationsMetaData]
})
export class VinnaComponent implements OnInit {
  @HostBinding('@routing') routing;
  @HostBinding('style.display') display = 'block';
  animationServiceEventsSubscription: Subscription;
  public routeDirections: IRouteDirection[];

  constructor(private Title: Title,
              private Meta: Meta,
              private animationService: AnimationService,
              routeDirections: RouteDirections) {
    this.routeDirections = routeDirections.vinna;
  }

  ngOnInit() {
    this.Title.setTitle('VINNA - Work | Alec Bertram');
    this.Meta.addTag({name: 'description', content: 'Vinna is a price comparison website aimed at the cycling market in the UK. Everyday we collect and aggregate prices for 300, 000 products across 43 retailers.'});
    this.routing = this.animationService.animationDirection();
    this.animationServiceEventsSubscription = this.animationService.emitCurrentDirection
      .subscribe((direction: any) => this.routing = direction);
  }

  go(direction: string, url: string) {
    return this.animationService.routingService(direction, url);
  }
  pan($event, url: string) {
    return this.animationService.mobileRoutingSerivce($event, url);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/work/vinna/vinna.component.ts